package de.oevbs.kunde.kundenportal2.model.services.inbox

import de.oevbs.kunde.kundenportal2.GeneralProgressStep
import de.oevbs.kunde.kundenportal2.model.services.delivery.Delivery
import dev.fritz2.core.Lenses

@Lenses
data class DeliveryState(
    val delivery: Delivery = Delivery(),
    val step: GeneralProgressStep = GeneralProgressStep.SUBMIT1,
    val initial: Delivery = delivery
) {
    companion object
}
